module.exports = require("@swa-ui/date");